<template>
  <v-container>
          <v-layout>
            <v-flex xs12>
              <v-spacer></v-spacer>
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Suche"
                  single-line
                  hide-details
                ></v-text-field>
              <v-data-table
                :rows-per-page-items="[25, 50, 75]"
                :headers="headers"
                :items="users"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left"><v-icon v-if="props.item.admin == 1">done</v-icon></td>
                  <td class="text-xs-right">
                    <EditUser :userId="props.item.id" @itemUpdated="_collectUsers_"/>
                    <DeleteButton :id="props.item.id" backendRoute="deleteuser" @itemDeleted="_collectUsers_"/>
                  </td>
                </template>
                <template v-slot:no-results>
                  <v-alert :value="true" color="error" icon="warning">
                    Ihre Suche nach "{{ search }}" Es wurden keine Ergebnisse gefunden.
                  </v-alert>
                </template>
              </v-data-table>
              <NewUser @itemCreated="_collectUsers_"/>
            </v-flex>
          </v-layout>
       </v-container>
</template>

<script>
import axios from 'axios';
  export default {
    data () {
      return {
        search: '',
        users: [],
        headers: [
          { text: 'E-mail', value: 'email', sortable: false},
          { text: 'Admin', value: 'admin', sortable: false},
          { text: ''}
        ]
      }
    },
    created() {
      this._collectUsers_()
    },
    methods: {
      _collectUsers_(){
        axios.get('users.php')
        .then(resp => {
          this.users = resp.data.data
        })
      },
    },
    watch: {
      dialog(val){
          if (!val) {
            this.password = ''
            this.email = ''
            this.response = ''
            this.showErrors = false
          }
      }
    },
    components: {
      'DeleteButton': () => import('../components/DeleteButton'),
      'NewUser': () => import('../components/users/NewUser'),
      'EditUser': () => import('../components/users/EditUser')
    }
  }
</script>
